export default __webpack_public_path__ + "static/media/ic_wmatic_225 (5).17174147.svg";